export default __webpack_public_path__ + "static/media/arrow-back.c39b37d1.svg";